import { Box, Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { CadastrarVincularCliente } from "../../../../../clientes/containers/CadastrarVincularCliente";
import { OperacaoCategoriasProdutosContainer } from "../../../../../produtos/containers/OperacaoCategoriasProdutosContainer";
import { CheckoutPaper } from "../../../../components/CheckoutPaper";
import { ClientePaper } from "../../../../components/ClientePaper";
import { MetodoPagamentoSelect } from "../../../../components/MetodoPagamentoSelect";
import { useOperacaoContext } from "../../../../contexts/OperacaoContext";
import { TipoPedido } from "../../../../enum/TipoPedido";
import { CategoriasContainer, Layer, ProdutosPaper } from "./styles";
import { useFetchCategorias } from "../../../../../produtos/hooks/useFetchCategorias";
import { useTamanhoTela } from "../../../../../core/hooks/useTamanhoTela";
import { CarrinhoMobilePaper } from "../../styles";
import { ProdutosCarrinhoContainer } from "../../../../../produtos/containers/ProdutosCarrinhoContainer";
import { IPagamentoPedido } from "../../../../interface/IPagamentoPedido";
import { useOperacaoEdicaoContext } from "../../../../contexts/OperacaoEdicaoContext";
import { ProdutosCarrinhoEdicaoContainer } from "../../../../../produtos/containers/ProdutosCarrinhoEdicaoContainer";
import { AlterarTipoPedidoSelect } from "../../../../components/AlterarTipoPedidoSelect";
import { Print } from "@mui/icons-material";
import { CheckoutEdicaoPaper } from "../../../../components/CheckoutEdicaoPaper";
import { BotoesAcoesCheckout } from "../../../../components/BotoesAcoesCheckout";
import { FidelidadeCardsWrapper } from "../../../../components/FidelidadeCardsWrapper";

export const OperacaoEdicaoRetirada = () => {
    const { modeloTela } = useTamanhoTela();
    const { categorias, isLoading } = useFetchCategorias();
    const {
        adicionarProduto,
        adicionarProdutosCombo,
        aumentarQuantidade,
        diminuirQuantidade,
        removerProduto,
        fecharPedido,
        loading,
        cancelarPedido,
        editarProduto,
        numeroTotalItens,
        pedido,
        alterarPagamentos,
        alterarTipo,
        abrirModalImpressao,
        abrirDrawerPagamento,
        abrirDrawerDividir,
        configuracaoNFCe,
        switchImprimirAutomatico,
        handleSwitchImprimirAutomatico,
        handleSwitchNotaFiscal,
        switchNotaFiscal,
        cupons,
        abrirDrawerCupons,
        aplicarCupom
    } = useOperacaoEdicaoContext();

    const handleAlterarPagamento = (pagamento?: IPagamentoPedido) => {
        if (!pagamento?.metodoPagamento) {
            alterarPagamentos(undefined);
        } else {
            alterarPagamentos([pagamento]);
        }
    }

    return (
        <Grid
            container
            spacing={0}
            sx={{ width: "100%", height: "100%" }}
            justifyContent={"center"}
            alignItems={"center"}
        >

            <Grid item xs={12} md={9} lg={9}>
                <ProdutosPaper variant="outlined">
                    <CategoriasContainer>
                        <OperacaoCategoriasProdutosContainer
                            categorias={categorias}
                            adicionarProduto={adicionarProduto}
                            adicionarProdutosComboExterno={adicionarProdutosCombo}
                            contexto={TipoPedido.retirada}
                            carrinhoContainer={
                                <ProdutosCarrinhoEdicaoContainer
                                    categorias={categorias}
                                    produtosCarrinho={pedido?.produtos ?? []}
                                    aumentarQuantidade={aumentarQuantidade}
                                    diminuirQuantidade={diminuirQuantidade}
                                    removerProduto={removerProduto}
                                    editarProduto={editarProduto}
                                />
                            }
                        />
                    </CategoriasContainer>
                </ProdutosPaper>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
                {pedido && (
                    <CheckoutEdicaoPaper
                        loading={loading}
                        pedidoSelecionado={pedido?.uuid}
                        valorTotalPedido={pedido?.valorTotal}
                        numeroTotalItens={numeroTotalItens}
                        numeroPedidoDiario={pedido?.numeroPedidoDiario}
                        opcoes={[
                            {
                                titulo: "Concluir",
                                funcao: fecharPedido,
                                atalho: "F8"
                            },
                            {
                                titulo: "Dividir pagamento",
                                funcao: abrirDrawerPagamento
                            },
                            {
                                titulo: "Dividir pedido",
                                funcao: abrirDrawerDividir
                            },
                            {
                                titulo: "Cancelar",
                                funcao: cancelarPedido,
                                desabilitado: false
                            }
                        ]}
                    >
                        <AlterarTipoPedidoSelect
                            tipo={pedido?.tipo}
                            alterarTipo={alterarTipo}
                        />
                        <Box sx={{ mb: '1rem', width: '100%' }}>
                            <ClientePaper
                                cliente={pedido?.cliente}
                                ocultar
                            />
                        </Box>
                        <FidelidadeCardsWrapper
                            cliente={pedido?.cliente}
                            cupons={cupons}
                            aplicarCupom={aplicarCupom}
                            adicionarProduto={adicionarProduto}
                            categorias={categorias || []}
                            produtos={pedido?.produtos || []}
                        />
                        <MetodoPagamentoSelect
                            pagamento={pedido?.pagamentos ? pedido?.pagamentos[0] : undefined}
                            onChange={handleAlterarPagamento}
                            valorTotal={pedido?.valorTotal}
                        />
                        <BotoesAcoesCheckout
                            switchImprimirAutomatico={switchImprimirAutomatico}
                            handleSwitchImprimirAutomatico={handleSwitchImprimirAutomatico}
                            switchNotaFiscal={switchNotaFiscal}
                            handleSwitchNotaFiscal={handleSwitchNotaFiscal}
                            configuracaoNFCeObrigatorio={configuracaoNFCe?.obrigatorio}
                            quantidadeCupons={cupons.length}
                            abrirDrawerCupons={abrirDrawerCupons}
                            abrirModalComandas={abrirModalImpressao}
                        />
                        {modeloTela == "mobile" && (pedido.produtos && pedido?.produtos?.length > 0) && (
                            <CarrinhoMobilePaper variant="outlined" sx={{ marginTop: "1rem" }}>
                                <ProdutosCarrinhoEdicaoContainer
                                    categorias={categorias}
                                    produtosCarrinho={pedido?.produtos ?? []}
                                    aumentarQuantidade={aumentarQuantidade}
                                    diminuirQuantidade={diminuirQuantidade}
                                    removerProduto={removerProduto}
                                    editarProduto={editarProduto}
                                />
                            </CarrinhoMobilePaper>
                        )}
                    </CheckoutEdicaoPaper>
                )}
            </Grid>
        </Grid>
    );
}